import { ReactNode } from 'react'
import styled from 'styled-components'
var fonstsize = 18
const isMobile = window.innerWidth < 712


export const CircleAnnotation2 = ({
  children,
  offsetx = 100,
  offsety = 0,
  textcolor = 'var(--text-color)',
}: {
  children: ReactNode
  offsetx?: number
  offsety?: number
  textcolor?: string
}) => {
  // var textanchor =
  //   angle === 90 || angle === 270
  //     ? 'middle'
  //     : angle > 90 && angle < 270
  //     ? 'end'
  //     : 'start'

  // var offsetx =
  //   angle === 90
  //     ? fonstsize * 1.5
  //     : angle > 0 && angle < 180
  //     ? fonstsize
  //     : fonstsize * 0.5

  // var labelPos = pointOnCircle(0, 0, size + offsetx, angle)
  var maxwidth = 150
  var maxheight = 60
  var textmovex =
    offsetx < 0
      ? offsetx - maxwidth
      : offsetx === 0
      ? -maxwidth / 2
      : offsetx 
  var textmovey =
    offsety < 0 ? offsety - maxheight*.5 : offsety === 0 ? -5 : offsety + 10

  var align = offsetx < 0 ? 'right' : offsetx === 0 ? 'center' : 'left'

  return (
    <g transform={`translate(${0},${0})`}>
      <foreignObject x={textmovex} y={textmovey} width={maxwidth} height={200}>
        <AnnoText

          style={{
            color:textcolor,
            textAlign: align as any,
            fontSize: isMobile ? '12px' : '12px',
          }}
        >
          <span>{children}</span>
        </AnnoText>
      </foreignObject>
      <line
        x1={offsetx}
        y1={offsety}
        stroke='var(--text-color)'
        strokeOpacity={.75}
        strokeWidth={1}
      />
      <AreaCircle r={isMobile?1.5:2} fill='#f00' />
    </g>
  )
}
const AnnoText = styled.div`
  font-size: 12px;
  line-height: 1.2em;

  span {
    background-color: var(--site-background);
    padding: 4px;
    display: inline-block;
  }
`
const AreaCircle = styled.circle`
  fill: var(--text-color);
  stroke: var(--text-color);
  stroke-width: 2;
  /* stroke-dasharray: 4 5; */
  stroke-linecap: round;
`
const Text = styled.text`
  font-weight: 700;
  font-size: ${fonstsize}px;
  color: var(--anno-text-color);
  @media screen and (max-width: 712px) {
    font-size: 14px;
  }
`

function pointOnCircle(cx: number, cy: number, r: number, angle_deg: number) {
  var angle_rad = (angle_deg * Math.PI) / 180
  var x = cx + r * Math.cos(angle_rad)
  var y = cy + r * Math.sin(angle_rad)
  return { x: x, y: y }
}
